var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable no-underscore-dangle */
import Cookie from 'universal-cookie';
var COOKIES = {
    CookiesMessage: {
        key: 'cookies-message',
        disabled: 'disabled',
    },
    WishlistItemsCount: 'wishlistItemsCount',
    CartItemsCount: 'cartItemsCount',
    CustomerFullName: 'customer.fullName',
    AkamaiExperientVariant: 'H24_AKAMAI_AUDIENCE_SEGMENTATION',
    UserClosedBanner: 'userClosedBanner',
};
var CookieStorage = /** @class */ (function () {
    /**
     * Creates an instance of universal cookie storage. Optional
     * cookie header string can be provided when the library is used
     * on the server
     *
     * @constructor
     * @param {string} cookieHeader Cookie header string
     */
    function CookieStorage(cookieHeader) {
        this.cookie = null;
        this.init(cookieHeader);
    }
    CookieStorage.normalizeNumber = function (value) {
        value = Number(value);
        return isNaN(value) ? 0 : Math.max(0, value);
    };
    CookieStorage.normalizeString = function (value) {
        return typeof value === 'string' ? value : '';
    };
    CookieStorage.prototype.init = function (cookieHeader) {
        this.cookie = new Cookie(cookieHeader);
    };
    CookieStorage.prototype.__get = function (key) {
        return this.cookie.get(key);
    };
    CookieStorage.prototype.__set = function (key, value, options) {
        return this.cookie.set(key, value, options);
    };
    /**
     * Returns `true` or `false` based on the
     * cookie banner being visible or not
     *
     * @returns {boolean}
     */
    CookieStorage.prototype.getIsCookieBannerVisible = function () {
        return (this.__get(COOKIES.CookiesMessage.key) !== COOKIES.CookiesMessage.disabled);
    };
    CookieStorage.prototype.getCustomer = function () {
        var customerCookie = CookieStorage.normalizeString(this.__get(COOKIES.CustomerFullName)).trim();
        var _a = __read(customerCookie.split('+'), 2), _b = _a[0], firstName = _b === void 0 ? '' : _b, _c = _a[1], lastName = _c === void 0 ? '' : _c;
        return {
            lastName: lastName,
            firstName: firstName,
            fullName: (firstName + " " + lastName).trim(),
            isLoggedIn: !!customerCookie,
        };
    };
    CookieStorage.prototype.getWishlistCount = function () {
        return CookieStorage.normalizeNumber(this.__get(COOKIES.WishlistItemsCount));
    };
    CookieStorage.prototype.setWishlistCount = function (count, options) {
        if (options === void 0) { options = {}; }
        this.__set(COOKIES.WishlistItemsCount, CookieStorage.normalizeNumber(count), options);
    };
    CookieStorage.prototype.getCartCount = function () {
        return CookieStorage.normalizeNumber(this.__get(COOKIES.CartItemsCount));
    };
    CookieStorage.prototype.getExperimentVariant = function () {
        return CookieStorage.normalizeString(this.__get(COOKIES.AkamaiExperientVariant)).trim();
    };
    /**
     * Returns `true` or `false` based on either
     * the user has closed the smart banner or not
     *
     * @returns {boolean}
     */
    CookieStorage.prototype.getIsSmartBannerClosed = function () {
        return !!this.__get(COOKIES.UserClosedBanner);
    };
    /**
     * Set the {userClosedBanner} cookie to true
     * with the expiration date provided as argument
     */
    CookieStorage.prototype.closeSmartBanner = function (options) {
        if (options === void 0) { options = {}; }
        this.__set(COOKIES.UserClosedBanner, true, options);
    };
    return CookieStorage;
}());
export { CookieStorage };
export default new CookieStorage();
